import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, Shield, Users, UserCog, Calendar, LogOut, Radio } from 'lucide-react';

export default function Sidebar({ user, currentPath, pendingAlerts, onLogout }) {
  const navigate = useNavigate();

  const navItems = [
    { path: '/', label: 'Dashboard', icon: LayoutDashboard, badge: pendingAlerts || null },
    { path: '/teams', label: 'Teams', icon: Shield },
    { path: '/personnel', label: 'Personnel', icon: Users },
    { path: '/roster', label: 'Shift Roster', icon: Calendar },
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">S</div>
        <div>
          <div className="sidebar-title">SOS GUARDIAN</div>
          <div className="sidebar-subtitle">Operations Center</div>
        </div>
      </div>

      <nav className="sidebar-nav">
        <div className="nav-section-label">Command</div>
        {navItems.map(item => (
          <button
            key={item.path}
            className={`nav-item ${currentPath === item.path ? 'active' : ''}`}
            onClick={() => navigate(item.path)}
          >
            <item.icon size={16} />
            {item.label}
            {item.badge > 0 && <span className="badge">{item.badge}</span>}
          </button>
        ))}

        <div className="nav-section-label">System</div>
        <button className="nav-item" style={{ marginTop: 'auto' }} onClick={onLogout}>
          <LogOut size={16} />
          Sign Out
        </button>
      </nav>

      {user && (
        <div style={{
          padding: '14px 20px', borderTop: '1px solid var(--border)',
          fontSize: '12px', color: 'var(--text-muted)'
        }}>
          <div style={{ fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 2 }}>
            {user.full_name}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <Radio size={10} color="var(--accent-emerald)" />
            {user.role?.toUpperCase()} — {user.badge_number || 'N/A'}
          </div>
        </div>
      )}
    </div>
  );
}
